import Vue from 'vue'
import * as util from '../../vendor/util'
import {cloneMe} from "../../vendor/util";
// import * as storesUtil from "@/bbn/storesUtil";
import * as sharedStoresStates from '../sharedStoresStates'
import {ebus} from "@/vendor/ebus";

function updateIsStoreSelected(_v) {
  let v = !!_v;
  sharedStoresStates.setIsStoreSelected(v);
  Vue.ls.set('isStoreSelected', v);
}

function doSetSelectedStore(state, _store) {
  // if (!_store) {
  //   state.selectedStore.filialnummer = '';
  //   state.isStoreSelected = false;
  //   updateIsStoreSelected(false)
  //   Vue.ls.remove('selectedStore');
  //   return;
  // }
  //
  // let store = cloneMe(_store);
  // store.orderingEnabled = 'orderingEnabled' in store && !!store.orderingEnabled;
  // Object.assign(state.selectedStore, store);
  //
  // //update appConfig
  // let appConfigUpdate = storesUtil.getAppConfigUpdate(store);
  // // console.log('appConfigUpdate: '+JSON.stringify(appConfigUpdate));
  // let isStoreSelected = state.selectedStore.filialnummer.length > 0;
  // updateIsStoreSelected(isStoreSelected)
  //
  // if (isStoreSelected) {
  //   Vue.ls.set('selectedStore', state.selectedStore);
  // } else {
  //   Vue.ls.remove('selectedStore');
  // }
  // ebus.$emit('appConfigUpdate', appConfigUpdate);
}

export default {
  state: {
    // storeId: '1',//from the query param
    inhouseStoreFilialnummer: '',
    selectedStore: {
      orderingEnabled: false,
      filialnummer: '',
      plz: '',
      strasse: '',
      ort: '',
      fee: 0,
      openingHours: {}
      // appConfig gets filled by selectedStore
    },
    stores: [
      // {
      //     "plz": "34456",
      //     "strasse": "ASdlkjsdflkj 23",
      //     "ort": "Maxdorf",
      //     "active": true,
      //     "orderingEnabled": true,
      //     "minOrderAmount": 10,
      //     "fee": 0,
      //     "openingHours": {
      //         "1": {
      //             "opened": false,
      //             "a": {
      //                 "fromHour": 10,
      //                 "fromMinute": 30,
      //                 "tillHour": 14,
      //                 "tillMinute": 0,
      //             },
      //             "b": {
      //                 "fromHour": 17,
      //                 "fromMinute": 0,
      //                 "tillHour": 21,
      //                 "tillMinute": 30
      //             }
      //         },
      //         "2": {
      //             "opened": true,
      //             "a": {
      //                 "fromHour": 10,
      //                 "fromMinute": 30,
      //                 "tillHour": 14,
      //                 "tillMinute": 0,
      //             },
      //             "b": {
      //                 "fromHour": 17,
      //                 "fromMinute": 0,
      //                 "tillHour": 21,
      //                 "tillMinute": 30
      //             }
      //         },
      //         "3": {
      //             "opened": true,
      //             "a": {
      //                 "fromHour": 10,
      //                 "fromMinute": 30,
      //                 "tillHour": 14,
      //                 "tillMinute": 0,
      //             },
      //             "b": {
      //                 "fromHour": 17,
      //                 "fromMinute": 0,
      //                 "tillHour": 21,
      //                 "tillMinute": 30
      //             }
      //         },
      //         "4": {
      //             "opened": true,
      //             "a": {
      //                 "fromHour": 10,
      //                 "fromMinute": 30,
      //                 "tillHour": 14,
      //                 "tillMinute": 0,
      //             },
      //             "b": {
      //                 "fromHour": 17,
      //                 "fromMinute": 0,
      //                 "tillHour": 21,
      //                 "tillMinute": 30
      //             }
      //         },
      //         "5": {
      //             "opened": true,
      //             "a": {
      //                 "fromHour": 10,
      //                 "fromMinute": 30,
      //                 "tillHour": 14,
      //                 "tillMinute": 0,
      //             },
      //             "b": {
      //                 "fromHour": 17,
      //                 "fromMinute": 0,
      //                 "tillHour": 21,
      //                 "tillMinute": 30
      //             }
      //         },
      //         "6": {
      //             "opened": true,
      //             "a": {
      //                 "fromHour": 10,
      //                 "fromMinute": 30,
      //                 "tillHour": 14,
      //                 "tillMinute": 0,
      //             },
      //             "b": {
      //                 "fromHour": 17,
      //                 "fromMinute": 0,
      //                 "tillHour": 21,
      //                 "tillMinute": 30
      //             }
      //         },
      //         "7": {
      //             "opened": true,
      //             "a": {
      //                 "fromHour": 10,
      //                 "fromMinute": 30,
      //                 "tillHour": 14,
      //                 "tillMinute": 0,
      //             },
      //             "b": {
      //                 "fromHour": 17,
      //                 "fromMinute": 0,
      //                 "tillHour": 21,
      //                 "tillMinute": 30
      //             }
      //         }
      //     }
      // }
    ],

  },
  actions: {},
  mutations: {
    // storeId(state, newValue) {
    //   if (newValue) {
    //     state.storeId = newValue;
    //     Vue.ls.set('storeId', newValue);
    //   }
    // },
    stores(state, newValue) {
      for (let c of newValue) {
        c.fullText = JSON.stringify(c).toLowerCase();
      }
      Vue.set(state, 'stores', [...newValue]);
      Vue.ls.set('stores', state.stores);

      //updateSelectedStore
      if(state.selectedStore.filialnummer){
        let s = state.stores.find(s => s.filialnummer === state.selectedStore.filialnummer);
        if (s) {
          doSetSelectedStore(state, s);
        }
      }
    },
    inhouseStoreFilialnummer(state, newValue) {
      state.inhouseStoreFilialnummer = newValue || '';
      Vue.ls.set('inhouseStoreFilialnummer', state.inhouseStoreFilialnummer);
    },
    selectedStore(state, _store) {
      doSetSelectedStore(state, _store);
    },
  },
  getters: {
    inhouseStoreFilialnummer: (state) => {
      let a = state.inhouseStoreFilialnummer;
      if (!a) {
        state.inhouseStoreFilialnummer = state.selectedStore.filialnummer;
      }
      return state.inhouseStoreFilialnummer;
    },
    stores: (state) => {
      return state.stores;//.sort((a, b) => a.plz.localeCompare(b.plz));
    },
    getStoreByFi: (state) => (filialnummer) => {
      return state.stores.find(s => s.filialnummer === filialnummer);
    },

    isStoreSelected(state) {
      return state.selectedStore.filialnummer.length > 0;
    },
    selectedStore: (state) => {
      return state.selectedStore;
    },
  }
};
